import styled from "styled-components";

export const Section = styled.section`
    margin: 5rem 0 5rem 0;
`;

export const TitleDiv = styled.div`
    display: flex;
    justify-content: center;
    margin: 1.56rem 0 1.56rem 0;
`;

export const Title = styled.h1`
    font-size: 1.25rem;
    color: #FFFFFF;
    font-weight: bold;

    @media (max-width: 425px) {
        font-size: 1rem;
    }
`;

export const FormationDiv = styled.div`
    margin: 0.62rem;    
    margin-top: 3.43rem;
`;

export const BoxTitle = styled.h1`
    font-size: 1.65rem;
    color: #FFFFFF;
    text-align: right;
    font-weight: bold;

    @media (max-width: 425px) {
        font-size: 1.35rem;
    }
`;

export const BoxSubtitle = styled.p`
    color: #FFFFFF;
    margin-top: -0.50rem;
    text-align: right;
`;